import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
};

const updateProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_PROJECT_INIT:
      return { ...state, loading: true, success: false, error: false };
    case types.UPDATE_PROJECT_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.UPDATE_PROJECT_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default updateProjectReducer;
